import { DeviceTransferStatus } from '@utils/enums';
import React, { createContext, ReactNode, useContext, useState } from 'react';

export type MovementPermissions = {
    isReceiver: boolean;
    canAddOrEditDevicesForProducer: boolean;
    canPerformMovement: boolean;
    canPreviewMovement: boolean;
    canViewMovement: boolean;
    isAccountAuthorizedForMovement: boolean;
    movementStatus: DeviceTransferStatus;
    isEligibleAccount: boolean;
};

export interface MovementContextState {
    // Keyed by consignment number.
    movementPermissions?: Record<string, MovementPermissions>;
    setMovementPermissions: React.Dispatch<React.SetStateAction<Record<string, MovementPermissions> | undefined>>;
}
const defaultMovementContextState: MovementContextState = {
    movementPermissions: {}, // Empty record as default
    setMovementPermissions: () => {}, // No-op function as default
};

const MovementContext = createContext<MovementContextState>(defaultMovementContextState);

// Hook to access the context
export const useMovementContext = (): MovementContextState => {
    const context = useContext(MovementContext);
    if (!context) {
        throw new Error('useMovementContext must be used within a MovementProvider');
    }
    return context;
};

// Provider component
export const MovementProvider = ({ children }: { children: ReactNode }) => {
    const [movementPermissions, setMovementPermissions] = useState<Record<string, MovementPermissions>>();

    const value = {
        movementPermissions,
        setMovementPermissions,
    };

    return <MovementContext.Provider value={value}>{children}</MovementContext.Provider>;
};
